// Arabic product names mapping
export const arabicProductNames = {
  'IPL 5052': 'جهاز براون إكسبرت برو لإزالة الشعر بالضوء النبضي المكثّف 5052 (IPL)',
  'IPL 5152': 'جهاز براون سيلك إكسبرت برو لإزالة الشعر بالضوء النبضي المكثّف مع رأس الدقة 5152 (IPL)',
  'IPL 7147': 'جهاز سكين آي.إكسبرت IPL من براون، إزالة الشعر في المنزل مع تطبيق مجاني PL7147',
  'Series 3 Shaver': 'ماكينات الحلاقة Series 3',
  'Series 5 Shaver': 'ماكينات الحلاقة Series 5',
  'Series 6 Shaver': 'ماكينات الحلاقة Series 6',
  'Series 9 Shaver': 'ماكينات الحلاقة Series 9',
  'Styler 40 lengths Series 3': 'ماكينة تهذيب اللحية 3 للتحديد الدقيق',
  'Styler 4in1': 'مجموعة تصفيف 4 في 1',
  'Styler 6in1': 'مجموعة تصفيف 6 في 1',
  'Styler 7in1': 'مجموعة تصفيف 7 في 1',
  'Styler 11in1': 'مجموعة تصفيف 11 في 1',
  'Body Grooming': 'أداة العناية بالجسم',
  'Oral B IO2': 'فرشاة الأسنان الكهربائية أورال بي IO 2',
  'Oral B IO5': 'فرشاة الأسنان الكهربائية أورال بي IO 5'
};

